var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Field, Int, ObjectType } from "type-graphql";
import { Node } from "../relay.js";
import { GlobalIdScalar } from "../scalars/GlobalId.js";
import { TimestampedResource } from "./Resource.js";
let PointEntryNode = class PointEntryNode extends TimestampedResource {
    id;
    comment;
    points;
    text() {
        return `${this.points} points${this.comment ? `: ${this.comment}` : ""}`;
    }
    getUniqueId() {
        return this.id.id;
    }
    static init(init) {
        return this.createInstance().withValues(init);
    }
};
__decorate([
    Field(() => GlobalIdScalar, { nullable: false }),
    __metadata("design:type", Object)
], PointEntryNode.prototype, "id", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", Object)
], PointEntryNode.prototype, "comment", void 0);
__decorate([
    Field(() => Int, { nullable: false }),
    __metadata("design:type", Number)
], PointEntryNode.prototype, "points", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", String)
], PointEntryNode.prototype, "text", null);
PointEntryNode = __decorate([
    ObjectType({
        implements: [Node],
    })
], PointEntryNode);
export { PointEntryNode };
//# sourceMappingURL=PointEntry.js.map